import Viewer from "./Viewer"
import Editor from "./Editor"

export default {
    name: "picture",
    title: "Picture",
    icon: require("./content-icon.svg"),
    category: "multimedia",
    Viewer,
    Editor,
    Preview: Viewer
}